// lib
import { OnDestroy, AfterViewInit, ViewChild, Input, OnInit, Directive } from '@angular/core';
import { NavController, ModalController, NavParams } from '@ionic/angular';

// elvispos
import { SAMService } from '../sam/sam.service';
import { Keyboard } from './keyboard/keyboard';
import { GUIService } from '../gui/gui.service';
import { SAM } from '../sam/base/sam';
import { ConfigService } from '../config.service';
import { SAMMessage } from '../sam/interfaces/sam-message';
import { BasePage, Helpers, InputComponent } from 'ngx-elvis-ds';
import { CartService } from '../services/cart.service';
import { ImageHelpers } from './image-helpers';
import { WindowRef } from '../window-ref.service';

export class PaymentDialogCommands {
  public static OPEN = ['PAYMENT_DIALOG_OPEN'];
  public static UPDATE = ['PAYMENT_DIALOG_UPDATE'];
  public static CLOSE = ['PAYMENT_DIALOG_CLOSE'];
}

@Directive()
export class BasePaymentPage extends BasePage implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('freeInput', { static: false }) freeInput: InputComponent;
  @Input() data: any = {};
  currentSam: SAMService | SAM;

  freeInputData: any = 0;
  paymentDeclarations: any[] = [];
  cashTender: any = [];
  keyboard: Keyboard;

  constructor(
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public navParams: NavParams,
    public sam: SAMService,
    public configSvc: ConfigService,
    public guiSvc: GUIService,
    public cartSvc: CartService,
    public winRef: WindowRef
  ) {
    super();
    this.setCurrentSam();
    this.subscribeListeners();
  }

  ngOnInit() {
    this.setTenderImagePaths();
    this.formatLabels();
    this.setCashTender();
    this.setPaymentDeclarations();
  }

  ngAfterViewInit() {
    if (window.innerWidth > 720) {
      this.guiSvc.initLocalKeyboard('paymentForm', '#payment-keypad-host', false, true, 'payment-keypad');
    }
  }

  ngOnDestroy() {
    this.unsubscribeListeners();
  }

  onCallback(success: boolean = false): void {
    if (!success) {
      this.currentSam.onSend({
        Command: 'ID_SELECTED',
        Val: `-1,${this.data.Callback},NULL`,
        parms: {
          TndId: '-1',
          TndAmt: this.data.Callback
        }
      });
    }
  }

  onTender(tender) {
    if (this.winRef.scrolling) {
      return;
    }

    if (!this.freeInputData) { this.freeInputData = 0; }

    if (tender.IsGlory && tender.GloryStatus === 'busy') {
      return;
    }

    this.currentSam.onSend({
      Command: 'ID_SELECTED',
      Val: `${tender.Id},${this.freeInputData},${tender.Descr}`,
      parms: {
        TndId: tender.Id.toString(),
        TndAmt: this.freeInputData.toString()
      }
    });
  }

  onTenderVoid(tender) {
    if (this.winRef.scrolling) {
      return;
    }

    this.currentSam.onSend({
      Command: 'ID_SELECTED',
      Val: `${tender.Id},${tender.Amt},${tender.Descr}`,
      parms: {
        TndId: tender.Id.toString(),
        TndAmt: tender.Amt.toString(),
        Index: tender.Index,
        Void: true
      }
    });
  }

  onDeclaration(declaration) {
    if (this.cashTender !== []) {
      const tender = this.cashTender[0];
      this.currentSam.onSend({
        Command: 'ID_SELECTED',
        Val: `${tender.Id},${declaration.Amount},${tender.Descr}`,
        parms: {
          TndId: tender.Id.toString(),
          TndAmt: declaration.Amount.toString(),
        }
      });
    }
  }

  resetFreeInput() {
    if (this.freeInput) { this.freeInput.value = 0; }
    this.freeInputData = 0;

    setTimeout(() => {
      if (document.forms['paymentForm']) { document.forms['paymentForm'].getElementsByTagName('input')[0].focus(); }
    }, 100);
  }

  // private

  private subscribeListeners() {
    this.subscriptions.modalEventsListener = this.sam.channels.dialogs.subscribe((msg: SAMMessage) => {
      if (PaymentDialogCommands.UPDATE.includes(msg.Command)) {
        this.data =  msg.parms;
        this.resetFreeInput();
        this.setTenderImagePaths();
        this.formatLabels();
        this.setCashTender();
      }
    });
  }

  private unsubscribeListeners() {
    this.subscriptions.modalEventsListener.unsubscribe();
  }

  private setCashTender() {
    if (this.data.Tenders && this.data.Tenders.length > 0) {
      this.cashTender = this.data.Tenders.filter((tender) => {
        return tender.IsCash === true;
      });
    }
  }

  private setPaymentDeclarations() {
    this.paymentDeclarations = this.configSvc.paymentSettings.paymentDeclarations;
  }

  private setTenderImagePaths() {
    if (this.data.Tenders) {
      for (const tender of this.data.Tenders) {
        if (tender.Img) {
          tender.image = ImageHelpers.getImageURL('tender-images', tender.Img, this.configSvc);
        }
      }
    }
  }

  private formatLabels() {
    if (this.data.n0Total) {
      this.data.n0Total = this.data.n0Total / this.configSvc.currency.divider;
    }
    if (this.data.n0Discount) {
      this.data.n0Discount = this.data.n0Discount / this.configSvc.currency.divider;
    }
    if (this.data.n0BalanceDue) {
      this.data.n0BalanceDue = this.data.n0BalanceDue / this.configSvc.currency.divider;
    }
  }

  private setCurrentSam() {
    this.currentSam = this.sam;
    // if (this.navParams.get('childSam')) {
    //   this.currentSam = this.navParams.get('childSam');
    // } else {
    // }
  }
}
